// API Configuration for AI Tutor V2
const config = {
  API_BASE_URL: process.env.NODE_ENV === 'production'
    ? 'https://ai-tutor-v2-backend.nfr-hk-obs.workers.dev'
    : 'http://localhost:5001',  // Different port for V2
  VERSION: '2.0.0',
  APP_NAME: 'AI Student Tutor V2'
};

export default config;